// @flow
import type { CoordinatesGroupClass, LocationGroupClass } from '@shared/Locations/types';

export const hydrateCoordinate = (coordinate: CoordinatesGroupClass): LocationGroupClass => ({
  id: coordinate.id,
  lat: coordinate.latitude ? parseFloat(coordinate.latitude) : null,
  lng: coordinate.longitude ? parseFloat(coordinate.longitude) : null,
});
